<template>
  <section class="roles-users-list">
    <header class="users-list-header">
      <h2 class="title" v-if="activeRole">
        <span>{{$t('roles.roleUsersTitle')}}</span>&nbsp
<!--        <trim-item class="trim-fix" :string="activeRole.name" :offset="70" :width="40"></trim-item>-->
      </h2>
      <div class="btns-cont">
        <div v-if="columns.length" @click="toggleAll" class="check-group">
          <checkAllIcon />
          <span class="check-number">{{checkedUsers.length}}</span>
          <span class="check-action">
          {{ checkedUsers.length === this.activeRole.users.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
        </div>
        <button type="button"
                @click="checkDelUser"
                v-if="activeRole && checkedUsers.length > 0"
                class="control-btn-new hover-blue-new hint-cont">
          <del-icon></del-icon>
          <p class="btn-hint btn-hint_small btn-hint_bottom">
            {{$t('btns.users.delUser')}}
          </p>
        </button>
        <button type="button"
                @click="inviteUser"
                class="btn-main-plus hint-cont">
          <plus-icon></plus-icon>
          <p class="btn-hint btn-hint_bottom hint-fix">
            {{$t('menu.sidebar.invite')}}
          </p>
        </button>
      </div>
    </header>

    <table-component :class-name="'roles-users-cont'"
                     :all-checked="allChecked"
                     :column-width="columnWidth"
                     :legend="createLegend()"
                     :columns="columns"
                     :clear-checked="clearMarker"
                     @filterName="filterName($event)"
                     @filterMail="filterMail($event)"
                     @changeCheckbox="checkedUsers = $event"
                     @checkAll="checkAll"></table-component>
  </section>
</template>

<script>
  import {mapGetters,mapMutations,mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {delItem2} from "../../../mixins/delItem2";
  import {showOverlay} from "../../../mixins/utils/showOverlay";
  import delIcon from '../../Svg/cart_control/delIcon'
  import plusIcon from '../../Svg/plusIcon'
  import groupIcon from '../../Svg/cart_control/groupIcon'
  import filterIcon from '../../Svg/filterIcon'
  import {loaderMixin} from "../../../mixins/utils/loaderMixin";
  import {tableComponentMixin} from "../../../mixins/utils/tableComponentMixin";
  import trimItem from '../../trimITem'
  import checkAllIcon from '../../Svg/projects/checkAllIcon'

  export default {
    name: 'roleUsersList',
    mixins: [tokenAndRoute, delItem2, loaderMixin, tableComponentMixin, showOverlay],
    components: {
      delIcon,
      plusIcon,
      groupIcon,
      filterIcon,
      trimItem,
      checkAllIcon
    },
    data() {
      return {
        checkedUsers: [],

        nameActive: false,
        nameUp: true,
        nameDown: true,

        mailActive: false,
        mailUp: true,
        mailDown: true,

        legend: [],
        //column width
        columnWidth: [363/630 * 100, (630 - 363)/630 * 100],
        //clearMarker
        clearMarker: false,
      }
    },
    computed: {
      ...mapGetters({
        activeRole: 'roles/activeRole'
      }),
      filteredItems() {
        let arr = [];
        if (this.activeRole && this.activeRole.users) {
          arr = this.activeRole.users.slice();

          if (this.nameActive) {
            arr.sort((a,b) => {
              let nameA = a.first_name;
              let nameB = b.first_name;

              if (this.nameDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              };
              if (this.nameUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          };
          if (this.mailActive) {
            arr.sort((a,b) => {
              let mailA = a.contacts.email;
              let mailB = b.contacts.email;

              if (this.mailDown) {
                if (mailA < mailB) return -1;
                if (mailA > mailB) return 1;
                return 0
              };
              if (this.mailUp) {
                if (mailA < mailB) return 1;
                if (mailA > mailB) return -1;
                return 0
              }
            })
          }
        };
        return arr;
      },
      columns() {
        return this.filteredItems.map(item => {
          return {
            id: item.id,
            item,
            cells: [
              {
                text: {
                  isLink: false,
                  text: `${item.first_name ? item.first_name : ''} ${item.second_name ? item.second_name : ''}`,
                },
                avatar: {
                  isAvatar: true,
                  avatarLink: item.contacts.avatar_url
                }
              },
              {
                text: {
                  isLink: true,
                  text: item.contacts.email,
                  link: `mailto:${item.contacts.email}`,
                  linkColor: false
                },
                avatar: {
                  isAvatar: false
                }
              }
            ]
          }
        })
      },
      allChecked() {
        if (this.activeRole && this.activeRole.users) {
          return this.checkedUsers.length == this.activeRole.users.length && this.checkedUsers.length > 0
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapMutations({
        showAddUserPopup: 'popups/addUser/SET_SHOW',
        setRoleId: 'popups/addUser/SET_ROLE_ID'
      }),
      ...mapActions({
        deleteRoleAssignment: 'roles/deleteRoleAssignment'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('users.table.contactPerson'),
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('users.table.email'),
            filterMethod: 'filterMail',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
        ]
      },
      toggleAll() {
        if (!this.allChecked) {
          this.checkedUsers = this.filteredItems
          this.clearMarker = false;
        } else {
          this.checkedUsers = []
          this.clearMarker = true;
        }
      },
      filterName(index) {
        //copy array
        this.copyLegend();
        //set default for all params
        this.setDefaultLegend();
        //set active in selected elem
        this.setActiveFilterLegend(index);

        this.mailUp = true;
        this.mailDown = true;
        this.mailActive = false;
        this.nameActive = true;

        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.nameUp) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.nameDown) {
          this.nameUp = true;
          this.nameDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },
      filterMail(index) {
        //copy array
        this.copyLegend();
        //set default for all params
        this.setDefaultLegend();
        //set active in selected elem
        this.setActiveFilterLegend(index);

        this.nameUp = true;
        this.nameDown = true;
        this.nameActive = false;
        this.mailActive = true;

        if (this.mailUp && this.mailDown) {
          this.mailDown = true;
          this.mailUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.mailUp) {
          this.mailDown = true;
          this.mailUp = false;
          this.setLegendDown(index);
          this.setLegendArr();

          return
        };

        if (this.mailDown) {
          this.mailUp = true;
          this.mailDown = false;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },
      checkAll() {
        if (this.allChecked) {
          this.checkedUsers = []
        } else {
          this.checkedUsers = this.activeRole.users
        }
      },
      inviteUser() {
        this.showOverlay(true);
        this.showAddUserPopup(true);
        this.setRoleId(this.activeRole.id)
      },
      checkDelUser() {
        let string = '';
        this.checkedUsers.forEach(item => {
          string += `${item.contacts.email} `
        });
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(2);
      },
      deleteItems2() {
        this.delUser()
      },
      async delUser() {
        this.showLoader();
        for (let i = 0; i < this.checkedUsers.length; i++) {
          let item = this.checkedUsers[i];
          await this.deleteRoleAssignment({token: this.token, userId: item.id, roleId: this.activeRole.id})
        };
        this.clearMarker = true;
        this.checkedUsers = [];
        this.clearMarker = false;
        this.hideLoader()
      }
    }
  }
</script>

<style lang="scss" scoped>
.users-list-header {
  position: sticky;
  top: 80px;
  z-index: 1;
  background: $lightGrey;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.roles-users-list {
  width: calc(100% - 420px - 80px);
}

.check-group {
  margin-right: 10px;
  min-width: 150px;
  height: 40px;
  border: 1px solid rgba(16, 156, 241, 0.36);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: #109CF1;

  svg {
    margin-right: 10px;
    margin-left: 18px;
  }

  .check-number {
    margin-right: auto;
  }

  .check-action {
    cursor: pointer;
    margin: 0 18px;
  }
}

.title {
  font-family: $mm;
  font-size: 16px;
  letter-spacing: .25px;
  white-space: nowrap;
  max-width: 70%;
}

.list-legend {
  display: flex;
  align-items: center;
  padding: 0 10px 15px;
  border-bottom: 1px solid $grey;
  margin-top: 30px;

}

.header-label {
  font-family: $mr;
  font-size: 13px;
  opacity: .5;
  cursor: pointer;
}

.btns-cont {
  display: flex;
  align-items: center;

  margin: 0 -10px;

  button {
    margin: 0 10px;
  }
}

.check-cont_small .check-label::before {
  border: 2px solid $grey;
  width: 12px;
  height: 12px;
}

.roles-users-cont {
  margin-top: 30px;
}
.hint-fix {
   left: calc(50% - 85px);
 }
//fix
.users-list-header .trim-fix {
  line-height: 28px;
}
//630
</style>
<style lang="scss">
.cell2 > div.avatar-wrap {
  width: 35px!important;
}
</style>
